<template>
  <v-app :style="customColors">
    <LoadingWidget color="custom-primary" v-if="loading" />
    <transition name="fade">
      <template v-if="!loading">
        <v-main>
          <router-view v-bind="$route.meta" />
        </v-main>
      </template>
    </transition>
  </v-app>
</template>

<script>
import LoadingWidget from "./components/widgets/LoadingWidget.vue";

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.updateDocumentTitle();
  },
  mounted() {
    this.$rest("config")
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => this.getCategories())
      .catch(() => this.$router.push("/error404"))
      .finally(() => (this.loading = false));
  },
  computed: {
    customColors() {
      return {
        "--custom-btn-bg-color": this.config.btn_bg_color,
        "--custom-btn-text-color": this.config.btn_text_color,
        "--custom-body-text-color": this.config.body_color,
      };
    },
    config() {
      return this.$rest("config").item;
    },
    name() {
      return this.config.meta_title || null;
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();
    },
    name() {
      this.updateDocumentTitle();
    },
  },
  methods: {
    updateDocumentTitle() {
      document.title = !this.name ? "Meus Contatos" : `${this.name}`;
    },
    getCategories() {
      this.$rest("categories").get();
    },
  },
  components: {
    LoadingWidget,
  },
};
</script>
